import { format } from 'date-fns';

export const CLIENT_FALLBACK = '#90A4AE';
export const JOURS = ['DI', 'LU', 'MA', 'ME', 'JE', 'VE', 'SA'];
export const GREEN = '#2e7d32';
export const RED = '#d32f2f';

export const COLUMNS = [
  { label: 'Jour', width: 90 },
  { label: 'Client', width: 160 },
  { label: 'Tournée', width: 220 },
  { label: 'Lavés / Imp. / Prévu', width: 130, align: 'center' },
  { label: '1er lavage', width: 80, align: 'center' },
  { label: 'Dernier lavage', width: 90, align: 'center' },
  { label: 'Temps total', width: 90, align: 'right' },
  { label: 'Laveuse', width: 150 },
  { label: 'Équipage', width: 150 },
  { label: 'Observation', width: 190 },
  { label: '', width: 48, align: 'center' },
];
export const NB_COLS = COLUMNS.length;

export function normalizeColor(c) {
  if (!c || typeof c !== 'string') return null;
  const s = c.startsWith('#') ? c : `#${c}`;
  return /^#[0-9a-fA-F]{6}$/.test(s) ? s : null;
}

export function readableText(bg) {
  const c = normalizeColor(bg);
  if (!c) return '#1a1a1a';
  const r = parseInt(c.slice(1, 3), 16);
  const g = parseInt(c.slice(3, 5), 16);
  const b = parseInt(c.slice(5, 7), 16);
  const lum = 0.299 * r + 0.587 * g + 0.114 * b;
  return lum > 150 ? '#1a1a1a' : '#ffffff';
}

export function jourLabel(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  return `${JOURS[d.getDay()]} ${format(d, 'dd/MM')}`;
}

export function formatTime(isoString) {
  if (!isoString) return '—';
  return new Date(isoString).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

export function formatDuration(minutes) {
  if (minutes == null) return '—';
  return `${Math.floor(minutes / 60)}h ${minutes % 60}min`;
}

// Tournée incomplète : moins de bacs traités (lavés + impossibles) que prévu.
export function isIncomplete(row) {
  const prevu = row.nbBacsPrevu ?? 0;
  if (prevu <= 0) return false; // pas de prévu fiable → on ne juge pas
  return (row.nombreLaves ?? 0) + (row.nombreLavageImpossible ?? 0) < prevu;
}

// Badge rouge si les impossibles dépassent 3% du total (prévu si dispo, sinon traité).
export function impossibleHigh(row) {
  const imp = row.nombreLavageImpossible ?? 0;
  if (imp === 0) return false;
  const prevu = row.nbBacsPrevu ?? 0;
  const denom = prevu > 0 ? prevu : (row.nombreLaves ?? 0) + imp;
  if (denom === 0) return true;
  return imp > 0.03 * denom;
}

// Bordures du cadre agence (couleur agence) selon les côtés à tracer.
export function frameSx(color, top, bottom, left, right) {
  const b = `2px solid ${color}`;
  const s = {};
  if (top) s.borderTop = b;
  if (bottom) s.borderBottom = b;
  if (left) s.borderLeft = `3px solid ${color}`;
  if (right) s.borderRight = b;
  return s;
}

// Pour une liste ordonnée, calcule par index { show, span } des runs consécutifs de même clé.
export function computeRuns(rows, keyFn) {
  const res = new Array(rows.length);
  let i = 0;
  while (i < rows.length) {
    const k = keyFn(rows[i]);
    let j = i + 1;
    if (k !== null && k !== undefined && k !== '') {
      while (j < rows.length && keyFn(rows[j]) === k) j++;
    }
    res[i] = { show: true, span: j - i };
    for (let x = i + 1; x < j; x++) res[x] = { show: false, span: 0 };
    i = j;
  }
  return res;
}

export function sums(rows) {
  return {
    laves: rows.reduce((s, r) => s + (r.nombreLaves ?? 0), 0),
    imp: rows.reduce((s, r) => s + (r.nombreLavageImpossible ?? 0), 0),
    prevu: rows.reduce((s, r) => s + (r.nbBacsPrevu ?? 0), 0),
  };
}
